import React from 'react';
import { useAuth } from '../context/AuthContext';
import StudyAbroadDashboard from './StudyAbroadDashboard';
import WorkDashboard from './Work/WorkDashboard';
import AdminDashboard from './Admin/AdminDashboard';

const Dashboard = () => {
  const { user } = useAuth();

  if (user?.isAdmin) {
    return <AdminDashboard />;
  }

  if (user?.role === 'study') {
    return <StudyAbroadDashboard />;
  }

  if (user?.role === 'work') {
    return <WorkDashboard />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <p className="text-gray-600">Invalid user role</p>
    </div>
  );
};

export default Dashboard;
